import React from 'react';
import GalleryArrow from '../../../../GalleryArrow/GalleryArrow';
import { getNextIcon, getPrevIcon } from '../../../../../helpers/arrowIconIdentifier';

export const swiperArrowClassName = 'cell-gallery-arrow';

const getCellGallerySwiperParams = ({ isMobile, isRtl, className, title = {}, isLazy, withoutLoop }) => {
  const arrowProps = {
    className,
    isMobile,
    globalClassName: swiperArrowClassName
  };

  const { prevParams = '', nextParams = '' } = title;
  const prevIconClass = getPrevIcon(isMobile, isRtl).replace(/\./g, '');
  const nextIconClass = getNextIcon(isMobile, isRtl).replace(/\./g, '');
  const prevNavElement = `cell-swiper-${prevIconClass}`;
  const nextNavElement = `cell-swiper-${nextIconClass}`;

  const lazyLoadParams = isLazy
    ? {
      preloadImages: false,
      lazy: {
        loadOnTransitionStart: true
      }
    }
    : {};

  return ({
    spaceBetween: 10,
    slidesPerView: 1,
    rebuildOnUpdate: true,
    ...lazyLoadParams,
    navigation: {
      prevEl: `.${prevNavElement}`,
      nextEl: `.${nextNavElement}`,
      disabledClass: 'disabled-arrow'
    },
    renderCustomPrevButton: () => (
      <GalleryArrow
        position={isRtl ? 'right' : 'left'}
        title={prevParams}
        navClass={prevNavElement}
        {...arrowProps}
      />
    ),
    renderCustomNextButton: () => (
      <GalleryArrow
        position={isRtl ? 'left' : 'right'}
        title={nextParams}
        navClass={nextNavElement}
        {...arrowProps}
      />
    )
  });
};

export default getCellGallerySwiperParams;
